import React, { useState } from 'react';
import { Container, Form, Button, Alert, Card } from 'react-bootstrap';

const TdsTcsCalculator: React.FC = () => {
  const [amount, setAmount] = useState('');
  const [deductionDate, setDeductionDate] = useState('');
  const [depositDate, setDepositDate] = useState('');
  const [filingDate, setFilingDate] = useState('');
  const [dueDate, setDueDate] = useState('');
  const [interest, setInterest] = useState<number | null>(null);
  const [lateFee, setLateFee] = useState<number | null>(null);
  const [error, setError] = useState<string | null>(null);

  const calculate = () => {
    setError(null);
    setInterest(null);
    setLateFee(null);

    if (!amount || !deductionDate || !depositDate || !filingDate || !dueDate) {
      setError('Please fill in all fields.');
      return;
    }

    const tdsAmount = parseFloat(amount);
    const dedDate = new Date(deductionDate);
    const depDate = new Date(depositDate);
    const filDate = new Date(filingDate);
    const dDate = new Date(dueDate);

    // Interest Calculation
    let totalInterest = 0;
    // Late deduction interest
    const dedMonthDiff = (depDate.getFullYear() - dedDate.getFullYear()) * 12 + (depDate.getMonth() - dedDate.getMonth());
    if (dedMonthDiff > 0) {
        totalInterest += tdsAmount * 0.01 * dedMonthDiff;
    }

    // Late deposit interest
    const depMonthDiff = (filDate.getFullYear() - dDate.getFullYear()) * 12 + (filDate.getMonth() - dDate.getMonth());
    if (depMonthDiff > 0) {
        totalInterest += tdsAmount * 0.015 * depMonthDiff;
    }
    setInterest(totalInterest);

    // Late Fee Calculation
    const dayDiff = Math.ceil((filDate.getTime() - dDate.getTime()) / (1000 * 3600 * 24));
    if (dayDiff > 0) {
      const fee = dayDiff * 200;
      setLateFee(Math.min(fee, tdsAmount));
    }
  };

  return (
    <Container className="py-5">
      <h2 className="text-center mb-4">TDS/TCS Late Filing Interest and Fee Calculator</h2>
      {error && <Alert variant="danger">{error}</Alert>}
      <Form>
        <Form.Group className="mb-3">
          <Form.Label>TDS/TCS Amount</Form.Label>
          <Form.Control type="number" placeholder="Enter TDS/TCS amount" value={amount} onChange={e => setAmount(e.target.value)} />
        </Form.Group>
        <Form.Group className="mb-3">
          <Form.Label>Date of Deduction/Collection</Form.Label>
          <Form.Control type="date" value={deductionDate} onChange={e => setDeductionDate(e.target.value)} />
        </Form.Group>
        <Form.Group className="mb-3">
          <Form.Label>Date of Deposit</Form.Label>
          <Form.Control type="date" value={depositDate} onChange={e => setDepositDate(e.target.value)} />
        </Form.Group>
        <Form.Group className="mb-3">
          <Form.Label>Due Date of Filing Return</Form.Label>
          <Form.Control type="date" value={dueDate} onChange={e => setDueDate(e.target.value)} />
        </Form.Group>
        <Form.Group className="mb-3">
          <Form.Label>Actual Date of Filing Return</Form.Label>
          <Form.Control type="date" value={filingDate} onChange={e => setFilingDate(e.target.value)} />
        </Form.Group>
        <Button variant="primary" onClick={calculate}>Calculate</Button>
      </Form>

      {(interest !== null || lateFee !== null) && (
        <Card className="mt-4">
          <Card.Body>
            <Card.Title>Results</Card.Title>
            {interest !== null && <p>Interest Payable: ₹{interest.toFixed(2)}</p>}
            {lateFee !== null && <p>Late Filing Fee: ₹{lateFee.toFixed(2)}</p>}
            <p className="mt-3 text-muted">Disclaimer: This calculator is for informational purposes only and does not constitute legal advice. Please consult with a tax professional for accurate calculations and advice.</p>
          </Card.Body>
        </Card>
      )}
    </Container>
  );
};

export default TdsTcsCalculator;
